import { FC } from "react";

import { env } from "~/env.ts";
import { tw } from "~/utils";

interface SuccessMessageProps {
  className?: string;
  platformUrl?: string;
}

export const SuccessMessage: FC<SuccessMessageProps> = ({
  className,
  platformUrl = env.VITE_MIGHTY_PROFILE_URL,
}) => {
  return (
    <div
      className={tw(
        "bg-lightGreen flex w-full items-start gap-3 rounded-sm p-4",
        className,
      )}
    >
      <p className="text-indigo text-sm font-normal">
        Your information has been updated. Please note that it may take up to 24
        hours for the changes to appear on your community profile.{" "}
        <a
          href={platformUrl}
          className="hover:text-vivid-blue-purple underline transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here
        </a>{" "}
        to return to the Elektra Health platform.
      </p>
    </div>
  );
};
